<template>
  <v-dialog
      v-model="modal"
      width="20%"
    >
      <v-card v-if="!paymentDone">
        <v-card-title class="text-h5  lighten-2">
          Pago de dividendos
        </v-card-title>

        <v-card-text>
          <v-text-field 
            v-model="paymentAmount"
            type="number"
            hint="Monto a acreditar"
            label="Pago"
            :rules="[v => !!v || 'Monto requerido.',
                     v => v <= walletInfo.balance || 'Dinero insuficiente en billetera.'
                     ]"
          />
          <v-row v-if="buymentSummary">
            <v-col>
              {{buymentSummary}}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="cancel"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="payProjectDividends"
            :disabled="paymentAmount>=walletInfo.balance"
          >
            Pagar dividendos
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title class="text-h5  lighten-2">
          Pago de dividendos
        </v-card-title>

        <v-card-text>
          <v-row> Se pagaron dividendos exitosamente: </v-row>
          <v-row>  - ${{paymentAmount}} acreditado entre inversores. </v-row>
          <v-row>  - {{feedback}} cuenta{{(feedback>1)?'s':''}} de inversor{{(feedback>1)?'es':''}} acreditada{{(feedback>1)?'s':''}}.</v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="cancel"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  props:{
    dialog:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      walletInfo:{
        balance: 0,
        currency: 'ARS'
      },
      modal:false,
      paymentAmount:0,
      dividendsCommission: 0,
      buymentSummary:undefined,
      feedback:"",
      paymentDone:false
    }
  },
  async beforeMount(){
    this.modal = this.dialog
    this.$cf_api.getCommissions().then(response=>{ 
      this.dividendsCommission = parseFloat(response.data.dividendsPayment)
    }).catch(e=>{
      console.log('Error retrieving commission fees: ',e)
    })
    this.$cf_api.getUserFinancialAccounts(this.oidcUser.name).then(response=>{
      this.walletInfo.balance = response.data.accounts[0].balance
      this.walletInfo.currency = response.data.accounts[0].currencyIso
    }).catch(e=>{
      console.log('Error retreiving user account info: ',e)
    })
    
  },
  methods:{
    payProjectDividends(){
      this.$cf_api.payDividends(this.$route.params.id, this.paymentAmount).then(response=>{
        this.paymentDone = true
        this.feedback = response.data.InvAccountQuantity
      }).catch(e=>{
        console.log('Error paying dividends: ',e)
        this.$store.dispatch('setSnack','Dividendos no pudieron ser pagados. Intente de nuevo mas tarde.')
        this.cancel()
      })
    },
    cancel(){
      this.$emit('cancel')
    }
  },
  watch: {
    modal: function(newValue){
      if(!newValue){
        this.$emit('cancel')
      }
    },
    paymentAmount: function(newValue,oldValue){
      if(newValue != oldValue){
        if(newValue===0){
          this.buymentSummary = undefined
        } else{
          this.buymentSummary = `Del monto ingresado ${this.paymentAmount} se cobrara ${this.paymentAmount*this.dividendsCommission} (%${this.dividendsCommission}) como comisión.`
        }
      }
    }
  },
  computed:{
    ...mapGetters([
      'oidcUser'
    ]),
  }

}
</script>

<style>

</style>